import { render, staticRenderFns } from "./FeaturedHero.vue?vue&type=template&id=4b412f0e&scoped=true"
import script from "./FeaturedHero.vue?vue&type=script&lang=js"
export * from "./FeaturedHero.vue?vue&type=script&lang=js"
import style0 from "./FeaturedHero.vue?vue&type=style&index=0&id=4b412f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b412f0e",
  null
  
)

export default component.exports